import {
  Box,
  Button,
  Divider,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import SphTabList from "./SphTabList";
import { useState } from "react";
import CalenderTime from "./CalenderTime";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function CustomTabPanel(props) {
  const { data, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <SphTabList retValue={value} retData={data} />
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  carrierCode: PropTypes.node,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function SphList() {
  const [terminalValue, setTeminalValue] = useState(0);
  const [carrierCode, setCarrierCode] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectCarrier, setSelectCarrier] = useState([]);
  const [toSelect, setToSelect] = useState(false);
  const [fromSelect, setFromSelect] = useState(false);
  const [sphData, setSphData] = useState([]);
  const apiUrl = process.env.REACT_APP_APISITA;
  const handleChange = (event, newValue) => {
    setTeminalValue(newValue);
  };
  const getCRRCD = async () => {
    try {
      const response = await fetch(`${apiUrl}/sph/getCRRCD`);

      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.json();
      if (res.length === 0) {
      } else {
        const data = res.map((row, index) => ({
          carrier: row,
          id: index,
        }));
        setCarrierCode(data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    const fetchData = async () => {
      await getCRRCD();
    };
    fetchData();
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest("#standard-basic")) {
        setToSelect(false);
        setFromSelect(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleAutocompleteChange = (event, values) => {
    setSelectCarrier(values);
  };

  const toDateChangeClick = () => {
    setFromSelect(false);
    setToSelect(true);
  };
  const fromDateChangeClick = () => {
    setToSelect(false);
    setFromSelect(true);
  };
  const changeStart = (props) => {
    setStartDate(props.date);
  };

  const changeEnd = (props) => {
    setEndDate(props.date);
  };

  const changeClickFlag = () => {
    if (!startDate) {
      alert("시작날짜를 선택하여주세요");
      return;
    }
    if (!endDate) {
      alert("종료날짜를 선택하여주세요");
      return;
    }
    if (startDate >= endDate) {
      alert("시작날짜, 종료날짜 재확인");
      return;
    }

    if (selectCarrier.length == 0) {
      alert("항공사 코드를 선택하여주세요");
      return;
    }

    const dtoData = {
      carrierCode: selectCarrier.map((item) => item.carrier),
      startDate: moment(startDate).format("YYYYMMDD"),
      endDate: moment(endDate).format("YYYYMMDD"),
      terminalCode: "T1",
    };
    getSphSearch(dtoData);
  };

  const getSphSearch = async (dtoData) => {
    try {
      const response = await fetch(`${apiUrl}/sph/getSphVolume`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dtoData),
      });
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.json();
      if (res.length === 0) {
        alert("조회된 데이터가 없습니다.");
      } else {
        const data = res.map((row, index) => ({
          id: index,
          inoutFlag: row.inoutFlag,
          dateArray: row.dateArray,
          sphDto: row.sphDto.map((sphRow, index) => ({
            id: index,
            carrierCode: sphRow.carrierCode,
            sphCode: sphRow.sphCode,
            noOfPackage: sphRow.noOfPackage,
            netWeight: sphRow.netWeight,
          })),
        }));

        setSphData(data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          minHeight: "90vh",
          position: "relative",
        }}
      >
        <Tabs
          value={terminalValue}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="제 1 터미널" {...a11yProps(0)} />
          <Tab label="제 2 터미널" {...a11yProps(1)} />
          <Box sx={{ marginLeft: "10%" }}>
            <Divider orientation="vertical" sx={{ width: "3" }} />
          </Box>
          <Box sx={{ marginLeft: "10%" }}>
            <TextField
              id="standard-basic"
              variant="standard"
              size="small"
              placeholder="To"
              sx={{ marginRight: "10%", marginTop: "4%", width: "40%" }}
              value={startDate}
              onClick={toDateChangeClick}
              InputProps={{ readOnly: true }}
            />
            <TextField
              id="standard-basic"
              variant="standard"
              size="small"
              sx={{ marginTop: "4%", width: "40%" }}
              placeholder="From"
              value={endDate}
              onClick={fromDateChangeClick}
              InputProps={{ readOnly: true }}
            />
          </Box>
          <Box sx={{ marginLeft: "5%" }}>
            <Divider orientation="vertical" sx={{ width: "3" }} />
          </Box>
          <Box sx={{ minWidth: 200, marginLeft: "7%" }}>
            {" "}
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              options={carrierCode}
              disableCloseOnSelect
              getOptionLabel={(option) => option.carrier}
              onChange={(e) => {
                handleAutocompleteChange();
                e.stopPropagation();
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.carrier}
                </li>
              )}
              style={{ width: 350 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="항공사 코드"
                  size="small"
                  id="standard-basic"
                  variant="standard"
                />
              )}
              size="small"
            />
          </Box>
          <Box
            sx={{ alignContent: "center", marginRight: 0, marginLeft: "auto" }}
          >
            <Button
              size="small"
              variant="contained"
              sx={{ maxHeight: "35px" }}
              endIcon={<SearchIcon />}
              onClick={changeClickFlag}
            >
              조회
            </Button>
          </Box>
        </Tabs>
        <Box
          id="standard-basic"
          sx={{
            position: "absolute", // CalenderTime 컴포넌트를 absolute로 설정
            left: "26%",
            zIndex: 999, // 다른 요소 위에 겹치도록 zIndex 설정
            display: toSelect ? "block" : "none",
          }}
        >
          <CalenderTime props={changeStart} />
        </Box>
        <Box
          id="standard-basic"
          sx={{
            position: "absolute", // CalenderTime 컴포넌트를 absolute로 설정
            left: "38%",
            zIndex: 999, // 다른 요소 위에 겹치도록 zIndex 설정
            display: fromSelect ? "block" : "none",
          }}
        >
          <CalenderTime props={changeEnd} />
        </Box>
        <CustomTabPanel
          value={terminalValue}
          index={0}
          data={sphData}
        ></CustomTabPanel>
        <CustomTabPanel
          value={terminalValue}
          index={1}
          data={sphData}
        ></CustomTabPanel>
      </Box>
    </Box>
  );
}
